import { useMutation, useQuery, useQueryClient } from "react-query";
import useUserContext from "../contexts/UserContext";
import useApiHelper from "../services/useApiHelper";

export default function usePortalReports(agencyId) {
  const staleTime = 600000;
  const queryClient = useQueryClient();

  const { get, post, put, del } = useApiHelper();

  const portalStats = useQuery(
    ["portalStats", agencyId],
    () => get(`/Reports/${agencyId}/portalstats`).then((res) => res.data),
    {
      staleTime: staleTime,
    }
  );

  return {
    portalStats
  };
}
